import React from 'react';

import { useNavigate } from 'react-router-dom';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Button } from '../../components/Button';
import { MainLayout } from '../../components/MainLayout';
import { VisibleOnVersion } from '../../components/VisibleOnVersion';
import { colors } from '../../global';
import { useFirebaseAuth, useStoreData } from '../../hooks';
import { media } from '../../services/media';
import { themeStyles } from '../../services/themeStyles';
import { Storyblok } from '../../storyblok';
import { Message } from './Message';
import { StyledContainer } from './StyledContainer';
import { Ups } from './Ups';

interface ErrorPageProps {
    error: Storyblok.Content.ErrorType;
}

export const ErrorPage = ({ error }: ErrorPageProps) => {
    const navigate = useNavigate();

    /**
     * TODO: Add type
     */
    const errors = useStoreData().storyblok.ErrorItems.items.map((e: any) => {
        const {
            message,
            button_event: buttonEvent,
            button_label: buttonLabel,
            redirect_url: redirectUrl,
        } = e.content;

        return {
            slug: e.slug,
            message,
            buttonEvent,
            buttonLabel,
            redirectUrl,
        };
    });
    const { handleSignOutCurrentUser } = useFirebaseAuth();

    if (!errors || !error) {
        return null;
    }

    /** TODO: Add type */
    const { message, buttonLabel, buttonEvent, redirectUrl } =
        errors.find((m: any) => m.slug === error) || {};

    const handleButtonClick = () => {
        switch (buttonEvent) {
            case 'sign_out':
                handleSignOutCurrentUser().then(() => {
                    navigate('/login');
                });
                break;
            case 'homepage_redirect':
                navigate('/');
                break;
            case 'redirect':
                navigate(redirectUrl || '/');
                break;
            case 'reload':
            default:
                document.location.reload();
                break;
        }
    };

    return (
        <MainLayout className="ErrorPage">
            <StyledContainer sizeGroup="size-3">
                <Wrapper>
                    <VisibleOnVersion versions={['upscore', 'pengestyrke']}>
                        <Ups>Ups...</Ups>
                    </VisibleOnVersion>
                    {message && <Message>{message}</Message>}
                    {buttonLabel && (
                        <Button variant="boxed" onClick={handleButtonClick}>
                            {buttonLabel}
                        </Button>
                    )}
                </Wrapper>
            </StyledContainer>
        </MainLayout>
    );
};

const Upscore = themeStyles(
    'upscore',
    css`
        background: url('assets/images/bubble-red.svg');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;

        ${media.max('lg')} {
            padding: 100px 15px;
        }

        ${media.min('lg')} {
            padding: 180px 15%;
        }
    `,
);

const Formue = themeStyles(
    'formue',
    css`
        background-color: ${colors.camelot};
    `,
);

const Pengestyrke = themeStyles(
    'pengestyrke',
    css`
        background-color: ${colors.roseOfSharon};
    `,
);

const Wrapper = styled.div`
    position: relative;
    display: flex;
    flex-flow: column;
    align-items: center;
    text-align: center;

    ${media.max('md')} {
        padding: 30px 15px;
    }

    ${media.min('md')} {
        padding: 100px 15%;
    }

    color: ${colors.white};
    font-family: ${(props) => props.theme.headings.fontFamily};

    ${Formue}
    ${Pengestyrke}
    ${Upscore}
`;
